import { sendEventToRio, sendClickStreamInteractionEvent } from '../../utils/analytics';
import { getCiteThisForMeUrl } from '../../selectors';
export var handleButtonClick = function handleButtonClick(isSure, environment, onClickNoThanks) {
  var eventName = isSure ? 'go to ctfm page' : 'do not go to ctfm page';
  sendEventToRio(sendClickStreamInteractionEvent('click', {
    name: eventName,
    type: 'link',
    region_name: 'restrict free trials component'
  }, true));
  if (isSure) {
    window.open(getCiteThisForMeUrl(environment), '_blank') || window.location.replace(getCiteThisForMeUrl(environment));
  } else {
    onClickNoThanks && onClickNoThanks();
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/dist/esm/components/BlockedRegionContent/utils.js
// module id = 2599
// module chunks = 11